import { Loader2 } from 'lucide-react';
import { ACCENT } from '../../lib/uiTokens';

// Sjednocené stavy Pokladny — dřív měl každý sub-tab „Načítání…" jako holý text.
// Nyní spinner (ACCENT) konzistentní se zbytkem Financí.
export function Loading({ className = 'py-8' }) {
    return (
        <div className={`flex items-center justify-center ${className}`}>
            <Loader2 size={20} className="animate-spin" style={{ color: ACCENT }} />
        </div>
    );
}
